import React, { memo, useCallback, useState, useEffect, useMemo } from "react";
import styles from "./styles.m.css";
import { fetchCollection } from "../../../api";
import RetirementGuideLines from "../story/story-templates/shared/retirement-guidance";
import { Link } from "@quintype/components";
import Media from "react-media";

const RangeSlider = memo(({ classes, label, onChange, value, ...sliderProps }) => {
  const [sliderVal, setSliderVal] = useState(25);
  const [mouseState, setMouseState] = useState(null);

  const MAX = 10;

  const getBackgroundSize = () => {
    return { backgroundSize: `${(sliderVal * 100) / MAX}% 100%` };
  };

  useEffect(
    () => {
      setSliderVal(value);
    },
    [value]
  );

  const changeCallback = e => {
    setSliderVal(e.target.value);
  };

  useEffect(
    () => {
      if (mouseState === "up") {
        onChange(sliderVal);
      }
    },
    [mouseState]
  );

  return (
    <div className={`${styles["range-slider"]}`}>
      <p>{label}</p>
      <div className={`${styles["range-label"]}`}>
        <h3 className={`${styles["form-label"]}`}>Age of joining</h3>
        <h3>
          {sliderVal + " "}
          <span className={`${styles["yrs"]}`}> (Yrs)</span>
        </h3>
      </div>
      <input
        type="range"
        min="0"
        value={sliderVal}
        {...sliderProps}
        className={`${styles["slider"]} ${classes}`}
        id="myRange"
        onChange={changeCallback}
        onMouseDown={() => setMouseState("down")}
        onMouseUp={() => setMouseState("up")}
        onTouchStart={() => setMouseState("down")}
        onTouchEnd={() => setMouseState("up")}
        style={getBackgroundSize()}
      />
    </div>
  );
});

const APYCalculatorPage = () => {
  var data = {
    "18": [42, 84, 126, 168, 210],
    "19": [46, 92, 138, 183, 228],
    "20": [50, 100, 150, 198, 248],
    "21": [54, 108, 162, 215, 269],
    "22": [59, 117, 177, 234, 292],
    "23": [64, 127, 192, 254, 318],
    "24": [70, 139, 208, 277, 346],
    "25": [76, 151, 226, 301, 376],
    "26": [82, 164, 246, 327, 409],
    "27": [90, 178, 268, 356, 446],
    "28": [97, 194, 292, 388, 485],
    "29": [106, 212, 318, 423, 529],
    "30": [116, 231, 347, 462, 577],
    "31": [126, 252, 379, 504, 630],
    "32": [138, 276, 414, 551, 689],
    "33": [151, 302, 453, 602, 752],
    "34": [165, 330, 495, 659, 824],
    "35": [181, 362, 543, 722, 902],
    "36": [198, 396, 594, 792, 990],
    "37": [218, 436, 654, 870, 1087],
    "38": [240, 480, 720, 957, 1196],
    "39": [264, 528, 792, 1054, 1318]
  };

  const dummy = [1000, 2000, 3000, 4000, 5000];

  const [parentVal, setParentVal] = useState(25);
  const [dmp, setDmp] = useState(1000);
  const [monthlyInvestment, setMonthlyInvestment] = useState();
  const [yoc, setYOC] = useState();
  const [related, setRelated] = useState();
  const [totalContribution, setTotalContribution] = useState();

  useEffect(
    () => {
      fetchCollection("pension-schemes-and-benefits-special-stories", 0, 5, {})
        .then(relatedStories => {
          setRelated(relatedStories);
        })
        .catch(console.error);
      setMonthlyInvestment(data[parentVal][dummy.indexOf(dmp)]);
      setYOC(60 - parentVal);
    },
    [parentVal, dmp]
  );

  useEffect(
    () => {
      if (monthlyInvestment) {
        var x = monthlyInvestment * 12 * yoc;
        x = x.toString();
        var lastThree = x.substring(x.length - 3);
        var otherNumbers = x.substring(0, x.length - 3);
        if (otherNumbers !== "") lastThree = "," + lastThree;
        var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
        setTotalContribution(res);
      }
    },
    [monthlyInvestment]
  );

  const sliderValueChanged = useCallback(val => {
    setParentVal(val);
    setYOC(60 - val);
  });

  const sliderProps = useMemo(
    () => ({
      min: 18,
      max: 39,
      value: parentVal,
      step: 1,
      onChange: e => sliderValueChanged(e)
    }),
    [parentVal]
  );

  return (
    <div className={`${styles["apy-calculator"]}`}>
      <div className="container">
        <div className={`${styles["story-grid"]}`}>
          <div>
            <div className={`${styles["apy-calculator-hedaer"]}`}>
              <h1 className={`${styles["apy-calculator-hedaer-title"]}`}>Atal Pension Yojana Calculator</h1>
              {/* <span>Calculator</span> */}
              <img
                src="https://media.vikatan.com/vikatan/2022-08/9fcb7a4a-7924-40fc-95f7-8859991a5707/apy_header.png"
                alt=""
              />
            </div>
            <div className={`${styles["apy-calculator-form"]}`}>
              <div className={`${styles["form-fields"]}`}>
                <RangeSlider {...sliderProps} classes="additional-css-classes" />
                <div className={styles["pension-field"]}>
                  <h3 className={`${styles["form-label"]} ${styles["desired-amt"]}`}>
                    Select desired monthly pension*{" "}
                    {/* <span className={`${styles["age-txt"]}`}>(After attaining the age of 60)</span> */}
                  </h3>

                  <div className={`${styles["monthly-pension"]}`}>
                    <span
                      onClick={() => {
                        setDmp(1000);
                        setYOC(60 - parentVal);
                      }}
                      className={dmp === 1000 && `${styles["active"]}`}
                    >
                      ₹ 1,000
                    </span>
                    <span
                      onClick={() => {
                        setDmp(2000);
                        setYOC(60 - parentVal);
                      }}
                      className={dmp === 2000 && `${styles["active"]}`}
                    >
                      ₹ 2,000
                    </span>
                    <span
                      onClick={() => {
                        setDmp(3000);
                        setYOC(60 - parentVal);
                      }}
                      className={dmp === 3000 && `${styles["active"]}`}
                    >
                      ₹ 3,000
                    </span>
                    <span
                      onClick={() => {
                        setDmp(4000);
                        setYOC(60 - parentVal);
                      }}
                      className={dmp === 4000 && `${styles["active"]}`}
                    >
                      ₹ 4,000
                    </span>
                    <span
                      onClick={() => {
                        setDmp(5000);
                        setYOC(60 - parentVal);
                      }}
                      className={dmp === 5000 && `${styles["active"]}`}
                    >
                      ₹ 5,000
                    </span>
                  </div>
                </div>
              </div>
              <div className={styles["result-wrapper"]}>
                <div className={styles["result-padding"]}>
                  <h3 className={`${styles["form-label"]} ${styles["title"]}`}>Pension Details</h3>
                  <div className={`${styles["form-label-wrapper"]}`}>
                    <h3 className={`${styles["form-label"]}`}>Monthly Investment</h3>
                    <span>{monthlyInvestment ? `₹${monthlyInvestment}` : 0}</span>
                  </div>
                  <div className={`${styles["form-label-wrapper"]}`}>
                    <h3 className={`${styles["form-label"]}`}>Years of contribution</h3>
                    <span>
                      {monthlyInvestment && yoc ? `${yoc} ` : `${0} `}
                      <span className={`${styles["yrs"]}`}>(Yrs)</span>
                    </span>
                  </div>
                </div>
                <div className={`${styles["form-label-wrapper"]} ${styles["total-contribution"]}`}>
                  <h3 className={`${styles["form-label"]}`}>Total contribution</h3>
                  <span>{totalContribution ? `₹${totalContribution}` : 0}</span>
                </div>
              </div>
            </div>
            <p>*You will receive this monthly pension amount, once you attain the age 60.</p>
          </div>
          <Media query="(min-width: 767px)">
            {matches =>
              matches && (
                <div className="related-articles">
                  {related && (
                    <RetirementGuideLines
                      className={`${styles["related-stories"]} js-related-stories`}
                      collection={related}
                    />
                  )}
                </div>
              )
            }
          </Media>
          <div className={styles["faq-card"]}>
            <div className={styles["faq-container"]}>
              <h1>FAQs</h1>
              <h2>அடல் பென்ஷன் யோஜனா திட்டம் என்பது என்ன?</h2>
              <p>
                அடல் பென்ஷன் யோஜனா என்பது, மத்திய அரசின் இதர எந்த நலத் திட்டத்திலும் இணையாத அமைப்பு சாரா
                தொழிலாளர்களுக்கு ஓய்வுக் காலத்தில் நிலையான ஒரு தொகையை பென்ஷனாக வழங்கும் திட்டமாகும். இந்த பென்ஷன்
                தொகைக்கு மத்திய அரசின் உத்தரவாதம் இருக்கிறது. இதில் இணைய குறைந்தபட்ச வயது 18 மற்றும் அதிகபட்ச வயது 40.
              </p>
              <h2>இந்த திட்டத்திலிருந்து இடையிலேயே வெளியேறலாமா?</h2>
              <p>
                60 வயதுக்கு முன்பாகவே இந்தத் திட்டத்திலிருந்து வெளியேற அனுமதிக்கப்படுகிறது. அப்போது சந்தாதாரர் கட்டிய
                தொகை மற்றும் அதற்குரிய வருமானம் மட்டுமே வழங்கப்படுகிறது. அவருக்காக அரசு போட்ட பணமும் அதற்கான வருமானமும்
                தரமாட்டார்கள். இந்தத் திட்டத்தில் துணைவர் (கணவர்/மனைவி) இறந்துவிட்டால், மற்றவர் தொடர முடியும். இருவரும்
                இல்லை என்றால் நாமினிக்கு, அதுவரை சேர்ந்திருக்கும் தொகுப்பு நிதி வழங்கப்படும்.
              </p>
              <h2>குறைந்தபட்ச பங்களிப்பு எவ்வளவு?</h2>
              <p>
                இந்தத் திட்டத்தில் கட்டி வந்த பணத்துக்கு ஏற்ப, 60 வயதில் குறைந்தபட்ச பென்ஷன் ரூ.1000, அதிகபட்சம் ரூ.
                5,000 கிடைக்கும். ரூ.2,000, ரூ.3,000, ரூ.4,000 என்பது போலவும் பென்ஷன் கிடைக்கும் வகையில் திட்டங்களைத்
                தேர்வு செய்யலாம். 18 வயதுள்ள ஒருவர் 60 வயதில் ரூ.1,000 பென்ஷன் பெற விரும்பினால் அவர் மாதம் ரூ.42 முதலீடு
                செய்து வர வேண்டும். இதுவே 40 வயதில் ஒருவர் இந்தத் திட்டத்தில் சேர்ந்தால், அவர் மாதம் ரூ. 291 கட்ட
                வேண்டும். இடையில் அதிக தொகையை கட்டி பென்ஷனை அதிகரித்துக்கொள்ளும் வசதியும் இருக்கிறது.
              </p>
              <h2>இந்த கால்குலேட்டரைப் பயன்படுத்துவது எப்படி?</h2>
              <p>
                உங்கள் வயதையும், நீங்கள் பெற விரும்பும் பென்ஷன் தொகையையும் வைத்து, உங்களுடைய மாதாந்திர பங்களிப்பு
                எவ்வளவு என்பதை மேலே உள்ள கால்குலேட்டரில் கணக்கிட்டுக் கொள்ளலாம்.
              </p>
              <h2>இந்த திட்டத்தில் எப்படி சேர்வது?</h2>
              <p>
                இந்த அடல் பென்ஷன் திட்டத்தை ஒருவர் பொதுத்துறை மற்றும் தனியார் வங்கிகள், தபால் அலுவலகங்களில் தொடங்க
                முடியும். வங்கிக் கணக்கு மற்றும் ஆதார் அவசியம் இருக்க வேண்டும். ஆன்லைன் மூலமும் இந்தக் கணக்கைத் தொடங்க
                முடியும். வங்கிச் சேமிப்பு கணக்கிலிருந்து மாதம், காலாண்டு, அரையாண்டு அடிப்படையில் ஆட்டோ டெபிட் வசதி
                மூலம் சந்தா செலுத்தும் வசதியும் இருக்கிறது.
              </p>
              <h2>இந்த திட்டத்தின் கூடுதல் விவரங்களை எங்கே தெரிந்துகொள்ளலாம்?</h2>
              <p>
                அரசின் விவரமான கையேட்டை{" "}
                <Link href="https://www.pfrda.org.in/myauth/admin/showimg.cshtml?ID=1839">
                  இந்த லிங்க்கில் காணலாம்.
                </Link>
              </p>
            </div>
          </div>
          <Media query="(max-width: 767px)">
            {matches =>
              matches && (
                <div className="related-articles">
                  {related && (
                    <RetirementGuideLines
                      className={`${styles["related-stories"]} js-related-stories`}
                      collection={related}
                    />
                  )}
                </div>
              )
            }
          </Media>
        </div>
      </div>
    </div>
  );
};

export { APYCalculatorPage };
